import React from 'react'
import './style.css';

import ItemDetails from '../ItemDetails';
//import {useRouteMatch} from 'react-router-dom'; 

const ProductoItem = ({ lista }) => {
  return (

    <div className="contenedor-seccion">
      <h2 className="contenedor-seccion-titulo">
        <span>Productos</span>
      </h2>
      <div className="contenedor">
        {lista.map(producto => (
          <ItemDetails key={producto.id}
            id={producto.id}
            img={producto.imgUrl}
            precio={producto.precio}
            nombre={producto.nombre}
            categoria={producto.nombreCategoria}
            oferta={producto.oferta}
            novedades={producto.novedades}
            urlMercadoLibre={producto.url}
            descripcionItem={producto.descripcionItem}
          />
        ))}

      </div>
    </div>
  )
};

export default ProductoItem;
